/** @file Sets the placeholder a slot shows in setup pose (null = none), warning when it is unmapped. */
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { defineSetter } from '../_shared/defineSetter';
import { warnUnmappedPlaceholder } from './warnUnmappedPlaceholder';

const placeholderSetter = defineSetter({
  domain: 'slot',
  kind: 'slot',
  field: 'setup.attachment',
  schema: prim.name.nullable(),
  description: 'Set the placeholder a slot shows in setup pose (null = nothing); skins map it to an attachment, and a placeholder no skin maps yet is accepted with a warning.',
});

/** slot.setAttachment: the current placeholder is a no-op (R2-13); INFO at `value` when no skin maps a new one. */
export const command = defineCommand({
  ...placeholderSetter,
  apply(draft, input, ctx) {
    const slotId = ctx.resolve('slot', input.target);
    if (draft.slots[slotId]?.setup.attachment === input.value) return;
    placeholderSetter.apply(draft, input, ctx);
    if (typeof input.value === 'string') warnUnmappedPlaceholder(draft, slotId, input.value, ctx, 'value');
  },
});
